module.exports = __webpack_public_path__ + "img/Camasha-logo.13557ed4.jpg";